/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

jQuery.noConflict();

(function () {

    jQuery(document).ready(function ($) {

        const oneYear = 365;
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + oneYear);

        function ordinal(day) {
            if (day > 3 && day < 21) return `${day}th`;

            switch (day % 10) {
                case 1:
                    return `${day}st`;
                case 2:
                    return `${day}nd`;
                case 3:
                    return `${day}rd`;
                default:
                    return `${day}th`;
            }
        }

        $(document).on( 'click', ".stockist-result-custom-fields", function () {
            $('#location-section').removeClass('active');
            $('#service-section').addClass('active');
            $('.breadcrumb-Location').addClass('complete');
            $('.breadcrumb-Services').addClass('active');
            $('.breadcrumbs-progress-bar').css('width', '40%');

            const mmStore = jQuery(this).closest('.stockist-result').find('.stockist-result-name').text();
            const mmStoreAddress1 = jQuery(this).closest('.stockist-result').find('.stockist-result-addr-1').text();
            const mmStoreAddress2 = jQuery(this).closest('.stockist-result').find('.stockist-result-addr-locality').text();
            const mmStoreAddress3 = jQuery(this).closest('.stockist-result').find('.stockist-result-addr-country').text();
            const mmStoreAddress4 = jQuery(this).closest('.stockist-result').find('.stockist-result-phone a').text();

            const storeImage = jQuery(this)
                .closest('.stockist-result')
                .find('.stockist-result-image img');

            const defaultImage = $('.selected-store-image').attr('data-default-image');
            let storeImageUrl = defaultImage;
            if (
                storeImage.length &&
                storeImage.attr('src') &&
                storeImage.attr('src').trim() !== ''
            ) {
                storeImageUrl = storeImage.attr('src');
            }
            $('.selected-store-image').attr('src', storeImageUrl);

            $.cookie('mm-store-image', storeImageUrl, { expires: expirationDate });

            $.cookie('mm-store', mmStore, { expires: expirationDate });
            $.cookie('mm-store-address1', mmStoreAddress1, { expires: expirationDate });
            $.cookie('mm-store-address2', mmStoreAddress2, { expires: expirationDate });
            $.cookie('mm-store-address3', mmStoreAddress3, { expires: expirationDate });
            $.cookie('mm-store-address4', mmStoreAddress4, { expires: expirationDate });

            $('.mmStoreAddress').text(mmStore);
            $('.mmStoreAddress1').text(mmStoreAddress1);
            $('.mmStoreAddress2').text(mmStoreAddress2);
            $('.mmStoreAddress3').text(mmStoreAddress3);
            $('.mmStoreAddress4').text(mmStoreAddress4);
            $('.mmStorePhone').text(mmStoreAddress4);

        });

        $(document).on('change', '.service-dropdown', function () {

            const selectedService = $(this).val();
            const selectedTime = $(this).find(':selected').data('time');

            if (!selectedService) return;

            // Save cookies (same as before)
            $.cookie('mm-store-appointment', selectedService, { expires: expirationDate });
            $.cookie('mm-store-approx-time', selectedTime, { expires: expirationDate });

            // Update UI
            $('.selected-service-text').text(selectedService);

        });

        $(document).on( 'click', ".service-section .btn-next", function () {

            const mmStoreAppointmentDate = $('#datetimepicker').datetimepicker('getValue');
            const appointmentDate = new Date(mmStoreAppointmentDate);
            const months = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ];

            const dayOfWeek = appointmentDate.toLocaleString('en-US', { weekday: 'long' });
            const month = months[appointmentDate.getMonth()];
            const date = appointmentDate.getDate();
            const hours = appointmentDate.getHours();
            const minutes = appointmentDate.getMinutes();
            const ampm = hours >= 12 ? 'pm' : 'am';

            const formattedDate = `${dayOfWeek} ${month} ${date}th ${hours}:${minutes.toString().padStart(2, '0')}${ampm}`;

            const formattedDateOnly = `${dayOfWeek}, ${month} ${ordinal(date)}`;
            // const formattedTimeOnly = `${hours}:${minutes.toString().padStart(2, '0')}${ampm}`;
            $.cookie('mm-store-appointment-date', formattedDate, { expires: expirationDate });
            $.cookie('mm-store-date', formattedDateOnly, { expires: expirationDate });
            $.cookie('mm-store-iso-datetime', appointmentDate.toISOString(), { expires: expirationDate });


            $('.mmStoreAppointment').text($.cookie('mm-store-appointment'));
            $('.mmStoreAppointmentTime').text($.cookie('mm-store-approx-time'));
            $('.formattedDate').text($.cookie('mm-store-appointment-date'));
            $('.formattedDateOnly').text($.cookie('mm-store-date'));
            $('.formattedTimeOnly').text($.cookie('mm-store-time'));
            $('.mmStoreAddress').text($.cookie('mm-store'));
            $('.mmStoreAddress1').text($.cookie('mm-store-address1'));
            $('.mmStoreAddress2').text($.cookie('mm-store-address2'));
            $('.mmStoreAddress3').text($.cookie('mm-store-address3'));
            $('.mmStoreAddress4').text($.cookie('mm-store-address4'));

            const bookingFormData = getBookingFormData();

            $('#source').val(bookingFormData.source);
            $('#pick_a_service').val(bookingFormData.pick_a_service);
            $('#service_when').val(bookingFormData.service_when);
            $('#service_where').val(bookingFormData.service_where);

            $('#service-section').removeClass('active');
            $('#details-section').addClass('active');
            setBookingFormSourceCookie();
            $('.breadcrumb-Availability').addClass('complete');
            $('.breadcrumb-Details').addClass('active');
            $('.breadcrumbs-progress-bar').css('width', '80%');

            if($.cookie('mm-store-appointment') == 'Request a Service') {
                $('.Consult__banner').hide();
                $('.service__banner').show();
                $('.additional-service').clone().insertAfter('.personal-information__form');
            } else {
                $('.Consult__banner').show();
                $('.service__banner').hide();
                $('.additional-consult').clone().insertAfter('.personal-information__form');
            }
        });

        function setBookingFormSourceCookie() {
            var exp = new Date(Date.now() + 365 * 864e5).toUTCString();
            document.cookie = 'mm-form-source=booking; expires=' + exp + '; path=/';
        }

         $(document).on( 'click', "#next-button", setBookingFormSourceCookie);

        $(document).on( 'click', "#availability-back-button", function () {
            $('#availability-section').removeClass('active');
            $('#service-section').addClass('active');
            $('.breadcrumb-Availability').removeClass('active');
            $('.breadcrumb-Location').addClass('complete');
            $('.breadcrumb-Services').addClass('active');
            $('.breadcrumbs-progress-bar').css('width', '40%');
        });

        $(document).on( 'click', ".breadcrumb-Location, .reset-button", function () {
            $('.location-container').removeClass('active');
            $('#location-section').addClass('active');
            $('.breadcrumbs button').removeClass('complete');
            $('.breadcrumbs button').removeClass('active');
            $('.breadcrumb-Location').addClass('active');
            $('.breadcrumbs-progress-bar').css('width', '20%');

            var newUrl = window.location.href.replace(/(\?|&)contact_posted=true/, '');
            history.replaceState({}, document.title, newUrl);

            $('.details-section .additional-information__form').remove();
            var engagedContentAdded = false;
            var marriedContentAdded = false;
            var bothContentAdded = false;
        });

        function saveInputValue(inputId, cookieName) {
            var inputValue = $.cookie(cookieName);
            if (inputValue) {
                $(inputId).val(inputValue);
            }

            $(inputId).on('input', function() {
                inputValue = $(this).val();
                $.cookie(cookieName, inputValue);
            });
        }

        saveInputValue('#first-name', 'mm-customer-fname');
        saveInputValue('#last-name', 'mm-customer-lname');
        saveInputValue('#email', 'mm-customer-email');
        saveInputValue('#mobile', 'mm-customer-mobile');

        function getBookingFormData() {
            const storeAddress = [
                $.cookie('mm-store'),
                $.cookie('mm-store-address1'),
                $.cookie('mm-store-address2'),
                $.cookie('mm-store-address3'),
                $.cookie('mm-store-address4')
            ].filter(Boolean).join('\n');

            const serviceWhen = [$.cookie('mm-store-date'), $.cookie('mm-store-time')].filter(Boolean).join(', ');

            return {
                source: 'In-Store Appointment',
                pick_a_service: $.cookie('mm-store-appointment') || '',
                service_where: storeAddress,
                service_when: serviceWhen,
                Source: 'In-Store Appointment',
                'Pick a Service': $.cookie('mm-store-appointment') || '',
                Where: storeAddress,
                When: serviceWhen,
                where: storeAddress,
                when: serviceWhen
            };
        }

        function updateHulkFormBookingFields() {
            const $hulkFrame = $('.pxFormGenerator iframe');
            if (!$hulkFrame.length) return;

            const currentSrc = $hulkFrame.attr('src');
            if (!currentSrc) return;

            const iframeUrl = new URL(currentSrc, window.location.href);
            const bookingData = getBookingFormData();
            const bookingSignature = JSON.stringify(bookingData);
            if ($hulkFrame.attr('data-booking-signature') === bookingSignature) return;

            const referrerUrl = new URL(iframeUrl.searchParams.get('referrer_url') || window.location.href, window.location.href);

            Object.keys(bookingData).forEach(function (key) {
                iframeUrl.searchParams.set(key, bookingData[key]);
                referrerUrl.searchParams.set(key, bookingData[key]);
            });

            iframeUrl.searchParams.set('referrer_url', referrerUrl.toString());

            const nextSrc = iframeUrl.toString();
            if (nextSrc !== currentSrc) {
                $hulkFrame.attr('data-booking-signature', bookingSignature);
                $hulkFrame.attr('src', nextSrc);
            } else {
                $hulkFrame.attr('data-booking-signature', bookingSignature);
            }
        }

        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('contact_posted') && urlParams.get('contact_posted') === 'true') {
            $('.location-container').removeClass('active');
            $('#review-section').addClass('active');
            $('.breadcrumbs button').addClass('complete');
            $('.breadcrumbs button').addClass('active');
            $('.breadcrumbs-progress-bar').css('width', '100%');

            $('.mmStoreAppointment').text($.cookie('mm-store-appointment'));
            $('.mmStoreAppointmentTime').text($.cookie('mm-store-approx-time'));
            $('.formattedDate').text($.cookie('mm-store-appointment-date'));
            $('.formattedDateOnly').text($.cookie('mm-store-date'));
            $('.formattedTimeOnly').text($.cookie('mm-store-time'));
            $('.mmStoreAddress').text($.cookie('mm-store'));
            $('.mmStoreAddress1').text($.cookie('mm-store-address1'));
            $('.mmStoreAddress2').text($.cookie('mm-store-address2'));
            $('.mmStoreAddress3').text($.cookie('mm-store-address3'));
            $('.mmStoreAddress4').text($.cookie('mm-store-address4'));
            $('.mm-customer-name').text($.cookie('mm-customer-fname') + ' ' + $.cookie('mm-customer-lname'));
            $('.mm-customer-email').text($.cookie('mm-customer-email'));
            $('.mm-customer-mobile').text($.cookie('mm-customer-mobile'));

            const mapAddress = $.cookie('mm-store')+$.cookie('mm-store-address1');
            const mapUrl = `https://www.google.com/maps/embed/v1/place?q=${encodeURIComponent(mapAddress)}&key=AIzaSyBOkWD1GRC5Cr5ItA1uDtHt2HikAFvGi2I`;

            $('.review-maps iframe').attr('src', mapUrl);
        }

        // Define flags to track whether content has been added
        var engagedContentAdded = false;
        var marriedContentAdded = false;
        var bothContentAdded = false;

        function initializeDatepicker(selector) {
            jQuery(selector).datetimepicker({
                timepicker: false,
                scrollInput: false,
                scrollMonth: false,
                format: 'd.m.Y',
                yearStart: 1920,
                onGenerate: function (ct) {
                    jQuery(this).closest('.xdsoft_datetimepicker').addClass('engagement_datepicker');
                },
            });
        }

        $(document).on('click', ".details-section .engaged_or_married > label", function () {
            if (!bothContentAdded) {
                $(this).parent().addClass("active");
                $(".details-section .engaged_or_married").after("<div class='form-filed select-filed engaged_only checkbox-filed'><label>Engaged</label></div><div class='form-filed select-filed married_only checkbox-filed'><label>Married</label></div>");
                bothContentAdded = true;
            } else {
                $(this).parent().removeClass("active");
                $(".engaged_only").remove();
                $(".married_only").remove();
                engagedContentAdded = false;
                marriedContentAdded = false;
                bothContentAdded = false;
            }
        });

        $(document).on('click', ".engaged_only > label", function () {
            $(this).parent().addClass("active");
            if (!engagedContentAdded) {
                $(".engaged_only").append("<div class='form-filed input-filed'> <label for='engagement_date'>Please share your engagement date:</label> <input autocomplete='off' type='text' required name='contact[engagement_date]' id='engagement_date' class='input-group__field dtpicker'> </div>");

                initializeDatepicker('.dtpicker');
                engagedContentAdded = true;
            } else {
                $(this).parent().removeClass("active");
                $(".engaged_only .form-filed").remove();
                engagedContentAdded = false;
            }
        });

        $(document).on('click', ".married_only > label", function () {
            $(this).parent().addClass("active");
            if (!marriedContentAdded) {
                $(".married_only").append("<div class='form-filed input-filed'> <label for='wedding_date'>Please share your wedding date:</label> <input type='text' autocomplete='off' required name='contact[wedding_date]' id='wedding_date' class='input-group__field dtpicker'> </div>");

                initializeDatepicker('.dtpicker');
                marriedContentAdded = true;
            } else {
                $(this).parent().removeClass("active");
                $(".married_only .form-filed").remove();
                marriedContentAdded = false;
            }
        });

        $(document).on('click', '.change-store-btn', function () {
            $('#service-section').removeClass('active');
            $('#location-section').addClass('active');

            $('.breadcrumbs button').removeClass('active complete');
            $('.breadcrumb-Location').addClass('active');
            $('.breadcrumbs-progress-bar').css('width', '20%');
        });

        function checkBookingReady() {
            const service = $('.service-dropdown').val();
            const dateText = $('.selected-date-text').text();
            const timeText = $('.selected-time-text').text();

            const isDateSelected = dateText !== 'Select a date';
            const isTimeSelected = timeText !== 'Select a time';

            if (service && isDateSelected && isTimeSelected) {
                $('.btn--continue').addClass('active').prop('disabled', false);
                updateHulkFormBookingFields();
            } else {
                $('.btn--continue').removeClass('active').prop('disabled', true);
            }
        }

        // run on changes
        $(document).on('change', '.service-dropdown', checkBookingReady);

        $(document).on('click', '.btn--date-select', function () {

            const dateValue = $('#datetimepicker').datetimepicker('getValue');
            if (!dateValue) return;

            const appointmentDate = new Date(dateValue);

            const months = [
                'January','February','March','April','May','June',
                'July','August','September','October','November','December'
            ];

            const dayOfWeek = appointmentDate.toLocaleString('en-US', { weekday: 'long' });
            const month = months[appointmentDate.getMonth()];
            const date = appointmentDate.getDate();

            const formattedDateOnly = `${dayOfWeek}, ${month} ${ordinal(date)}`;

            $.cookie('mm-store-date', formattedDateOnly, { expires: expirationDate });
            $.cookie('mm-store-raw-date', dateValue, { expires: expirationDate });

            $('.selected-date-text').text(formattedDateOnly);

            checkBookingReady();
        });
        
        let isTriggering = false;
        $(document).on('click', '.time-slot', function () {

            if (isTriggering) return; 

            $('.time-slot').removeClass('active');
            $(this).addClass('active');

            const hour   = $(this).data('hour');
            const minute = $(this).data('minute');

            // Click the matching real xdsoft time slot
            const realSlot = $(`.xdsoft_time[data-hour="${hour}"][data-minute="${minute}"]`);
            if (realSlot.length) {
                isTriggering = true;
                realSlot.trigger('click');
                isTriggering = false;
            }

        });

        $(document).on('click', '.btn--time-select__wrap .btn--select', function () {

            const activeSlot = $('.time-slot.active');
            if (!activeSlot.length) return;

            const hour = activeSlot.data('hour');
            const label = activeSlot.text().trim();

            const ampm = Number(hour) === 11 ? 'am' : 'pm';

            const selectedTime = `${label}${ampm}`;

            $.cookie('mm-store-time', selectedTime, {
                expires: expirationDate
            });

            $('.selected-time-text').text(selectedTime);

            checkBookingReady();
        });

        const savedTime = $.cookie('mm-store-time');

        $('.time-slot').each(function () {
            if ($(this).text().toLowerCase().includes(savedTime)) {
                $(this).addClass('active');
            }
        });


        $('.service-dropdown').val('');
        $('.selected-date-text').text('Select a date');
        $('.selected-time-text').text('Select a time');

        $('.btn--continue').removeClass('active').prop('disabled', true);

    });

    jQuery('#datetimepicker').datetimepicker({
        inline: true,
        defaultTime:'12:00',
        defaultDate:'+1970/01/02',
        minDate: 0,
        timepickerScrollbar: false,
        lang: 'en',
        format: 'd/m/Y',
        scrollMonth: false,
        scrollInput: false,
        allowTimes: [
            '11:00', '11:30', '12:00', '12:30',
            '1:00', '1:30', '2:00', '2:30',
            '3:00', '3:30', '4:00', '4:30', '5:00'
        ],
        onGenerate: function () {
        const timeContainer = jQuery('.time-slots');
        timeContainer.empty();

        jQuery('.xdsoft_time').each(function () {

            const timeText = jQuery(this).text().trim();

            if (!timeText) return;

            const hour = jQuery(this).attr('data-hour');
            const minute = jQuery(this).attr('data-minute');
            const currentClass = jQuery(this).hasClass('xdsoft_current')
                ? 'active'
                : '';

            const button = `
                <button 
                    type="button" 
                    class="time-slot ${currentClass}"
                    data-time="${timeText}"
                    data-hour="${hour}"
                    data-minute="${minute}">
                    ${timeText}
                </button>
            `;

            timeContainer.append(button);

        });
    }
    });


})();


